import React from 'react';
import './CraftingBrands.css';

// --- IMPORT YOUR ASSETS HERE ---
// Ensure these files exist in your folder
import img1 from '../../../assets/RealWork/img (1).jpg';
import img2 from '../../../assets/RealWork/img (2).jpg';
import img3 from '../../../assets/RealWork/img (3).jpg';
import img4 from '../../../assets/RealWork/img (4).jpg';
import img5 from '../../../assets/RealWork/img (5).jpg';
import img6 from '../../../assets/RealWork/img (6).jpg';

const CraftingBrands = () => {
  // Define image data and their specific size type
  // Types: 'wide' (Rectangle) or 'square' (Square-ish)
  const portfolioItems = [
    { id: 1, src: img1, type: 'wide' },   // Rectangle
    { id: 2, src: img2, type: 'square' }, // Square
    { id: 3, src: img3, type: 'wide' },
    { id: 4, src: img4, type: 'square' },
    { id: 5, src: img5, type: 'wide' },
    { id: 6, src: img6, type: 'square' },
  ];

  return (
    <section className="crafting-section">
      <div className="crafting-header">
        <h2 className="crafting-title">Crafting Brands Through Real Work</h2>
      </div>

      {/* Marquee Wrapper */}
      <div className="marquee-wrapper">
        <div className="marquee-track">
          
          {/* --- Render List Once --- */}
          {portfolioItems.map((item) => (
            <div key={`a-${item.id}`} className={`work-card ${item.type}`}>
              <img src={item.src} alt={`Portfolio ${item.id}`} />
            </div>
          ))}

          {/* --- Render List Again (For seamless loop) --- */}
          {portfolioItems.map((item) => (
            <div key={`b-${item.id}`} className={`work-card ${item.type}`}>
              <img src={item.src} alt={`Portfolio ${item.id}`} />
            </div>
          ))}

        </div>
      </div>
    </section>
  );
};

export default CraftingBrands;